import { useHistoricoEscolhas } from '@/api/fichas';
import { ErroFormacao } from '@/components/formacao/avisos-formacao';
import { formatarDataHora } from '@/lib/format';

/**
 * Historico de trocas da ficha escolhida do item (GET /itens/:id/fichas/escolhas, `ficha.ver`, sem R$). Mais nova primeiro.
 * Versao anterior vazia = primeira escolha do item.
 */
export function HistoricoEscolhas({ itemId }: { itemId: string }) {
  const q = useHistoricoEscolhas(itemId);

  return (
    <section aria-label="Histórico de fichas escolhidas" className="rounded-2xl border border-border bg-card">
      <div className="border-b border-border px-5 py-4">
        <h2 className="text-title font-semibold">Histórico de fichas escolhidas</h2>
        <div className="text-small text-ink-muted">Quem trocou a versão que a formação e o orçamento usam, e quando.</div>
      </div>
      <div className="px-5 py-4">
        {q.isPending && <p role="status" className="text-small text-ink-muted">Carregando histórico…</p>}
        {q.isError && <ErroFormacao titulo="Não foi possível carregar o histórico" erro={q.error} onTentar={() => void q.refetch()} />}
        {q.data && q.data.length === 0 && <p className="text-small text-ink-muted">Nenhuma troca de ficha escolhida registrada para este item.</p>}
        {q.data && q.data.length > 0 && (
          <ol className="flex flex-col divide-y divide-border text-small" data-testid="historico-escolhas">
            {q.data.map((e) => (
              <li key={e.id} className="flex flex-col gap-0.5 py-2.5">
                <span className="tabular font-medium">
                  {formatarDataHora(e.createdAt)} · {e.fichaAnteriorVersao === null ? 'primeira escolha' : `versão ${e.fichaAnteriorVersao}`} → versão{' '}
                  {e.fichaNovaVersao ?? '—'}
                </span>
                <span className="text-caption text-ink-muted">
                  {e.usuarioNome ?? 'Usuário removido'}
                  {e.motivo ? ` · ${e.motivo}` : ''}
                </span>
              </li>
            ))}
          </ol>
        )}
      </div>
    </section>
  );
}
